/**
 * Returns a debounced version of the given callback, which delays execution
 * until after the specified timeout has elapsed since the last invocation.
 *
 * @param {() => void} callback - The function to debounce.
 * @param {number} timeout - The number of milliseconds to delay.
 * @returns {() => void} A debounced function that can be safely called repeatedly.
 */
export function debounce(callback, timeout) {
    let timeoutId;
    return () => {
        if (timeoutId != null) {
            window.clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(callback, timeout);
    };
}
